import React from 'react'
import { Skeleton } from '@material-ui/lab'
import PropTypes from 'prop-types'
import { useQuery } from '@tanstack/react-query'
import { makeStyles } from '@material-ui/core'
import { QUERY_KEYS } from '../../../../../api/queryKeys'
import { postNamedQuery } from '../../../../../service'
import { useAppContext } from '../../../../../redux/slices/appContext'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'auto',
    gap: 'var(--gap-md)'
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    padding: 'var(--padding-sm)',
    maxHeight: '120px',
    minHeight: 'fit-content',
    borderRadius: 'var(--border-radius-lg)',
    gap: 'var(--gap-xs)'
  }
})

export const AccountCategories = ({
  entityProps
}) => {
  const { clientId } = useAppContext()

  const classes = useStyles()

  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.entityGraphs, clientId, entityProps.levelTypeId, entityProps.levelId, 'accountCategories'],
    queryFn: async () => {
      const response = await postNamedQuery('levels', 'searchGroups', {
        skip: 0,
        take: 100,
        includes: { groupType: true },
        filters: {
          memberLevelTypeIds: [1],
          memberLevelIds: [entityProps.levelId]
        }
      })

      const groups = response?.data?.data || []

      // group by groupType
      return groups.reduce((acc, { groupType, ...group }) => {
        const existingGroupType = acc.find(item => item.groupTypeId === groupType?.groupTypeId)
        if (existingGroupType) {
          existingGroupType.groups.push(group)
        } else {
          acc.push({ ...groupType, groups: [group] })
        }
        return acc
      }, [])
    }
  })

  if (isLoading) {
    return (
      <>
        <hr className='w-full' />
        <div className={classes.accountListContainer}>
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton key={index} width='100%' height='38px' />
          ))}
        </div>
      </>
    )
  }

  if (!data?.length) {
    return (
      <>
        <hr className='w-full' />
        <p className='m-0 font-size-sm'>No categories found for this account</p>
      </>
    )
  }

  return (
    <>
      <hr className='w-full' />
      <div className={classes.container}>
        {data?.map((groupType) => (
          <div key={groupType.groupTypeId}>
            <p className='m-0 font-size-md'>{groupType.longName}</p>
            {groupType.groups.map((group) => (
              <div
                key={group.levelId}
                className={classes.group}
                style={{ backgroundColor: group.colorField || entityProps.color || 'var(--color-primary-400)' }}
              >
                <span className='font-size-sm'>{group.longName}</span>
                {!!group.description?.length && (<span className='font-size-xs'>{group.description}</span>)}
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  )
}

AccountCategories.propTypes = {
  entityProps: PropTypes.shape({
    levelTypeId: PropTypes.number.isRequired,
    levelId: PropTypes.number.isRequired,
    color: PropTypes.string
  })
}
